import { createSelector } from 'reselect';

// 1. Base selectors (no memo)
// These extract raw state fields and should be reused for memo selectors!
export const selectLeaderboard = (state) => state.ranking.leaderboard;
export const selectTopLeader = (state) => state.ranking.topLeader;
export const selectNextBatches = (state) => state.ranking.nextBatches;

// 2. Memoized selectors ("derived data")
export const selectBatchEntries = createSelector(
  [selectLeaderboard],
  (leaderboards) => Object.entries(leaderboards || {}) // Only recalculates if leaderboards changes!
);

export const selectTotalBatches = createSelector(
  [selectBatchEntries],
  (batchEntries) => batchEntries.length
);

export const selectTotalNextBatches = createSelector(
    [selectNextBatches],
    (batches)=>batches.length
)

export const selectFirstNameOfTopScorer = createSelector(
  [selectTopLeader],
  (topLeader) =>
    topLeader?.topRankerName
      ? topLeader.topRankerName.split(' ')[0]?.charAt(0)?.toUpperCase()
      : undefined
);

export const selectLastNameOfTopScorer = createSelector(
  [selectTopLeader],
  (topLeader) => {
    if (!topLeader?.topRankerName) return undefined;
    const str = topLeader.topRankerName.split(' ')[1];
    return str ? `${str[0].toUpperCase()}${str.slice(1)}` : undefined;
  }
);